// extracted by mini-css-extract-plugin
export default {"root":"Carousel_root__M5tGw","arrow":"Carousel_arrow__OgOpa","next":"Carousel_next__DIvCe"};